var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewWrapper',{staticClass:"not-found"},[_c('h1',[_vm._v(_vm._s(_vm.$t('view.notFound.headline')))]),_c('p',[_vm._v(_vm._s(_vm.$t('view.notFound.copy')))])])}
var staticRenderFns = []

export { render, staticRenderFns }